import { RankingRequest } from '@features/rankings/models/ranking.model'
import {
  parsePlayerComparisonToRankingRequest,
  parsePlayerMatchComparisonToRankingRequest
} from '@features/rankings/parsers/player-comparison-ranking.parser'
import {
  parsePlayerMatchToRankingRequest,
  parsePlayerToRankingRequest
} from '@features/rankings/parsers/player-ranking.parser'
import { PlayerHolder } from '@core/models/player.models'
import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { Aggregation, AggregationContext } from '@features/aggregations/models/aggregations.models'

export const resolvePlayerRankingRequestAdapter = (
  payload: ContextMenuItemEvent,
  aggregationMode: Aggregation,
  { isVsEnabled, isMatch }: AggregationContext
): RankingRequest => {
  const { context, value, mode } = getMetricValueAndContext<PlayerHolder>(payload, aggregationMode)

  if (isVsEnabled && isMatch) {
    return parsePlayerMatchComparisonToRankingRequest(context.comparison, value, mode)
  } else if (isVsEnabled && !isMatch) {
    return parsePlayerComparisonToRankingRequest(context.comparison, value, mode)
  } else if (!isVsEnabled && isMatch) {
    return parsePlayerMatchToRankingRequest(context.player, value, mode)
  } else {
    return parsePlayerToRankingRequest(context.player, value, mode)
  }
}
